import ReactDOM from "react-dom";
import { ModalContainer, ModalContent, ModalOverlay } from "../../../common/components/modal/CustomDetailModal";
import { Divider, Padding, Row, SingleScrollView, SizedBox } from "../../../common/components/CommonBaseComponents";
import CustomText, { C3Text, C4Text } from "../../../common/components/text/CustomText";
import CustomIcon from "../../../common/components/image/CustomIcon";
import React, { useEffect, useRef, useState } from "react";
import { TitleAndInput, TitleAndInputGrid } from "../../../common/components/input/TitleAndInput";
import SecondaryButton from "../../../common/components/button/SecondaryButton";
import CustomSegmentedControl from "../../../common/components/button/CustomSegmentedControl";
import styled from "styled-components";
import CustomImage from "../../../common/components/image/CustomImage";
import PrimaryButton from "../../../common/components/button/PrimaryButton";
import DeviceLayoutDummyData from "../../../dummy/DeviceLayoutDummyData";
import DeviceLayoutWasherDummyData from "../../../dummy/DeviceLayoutWasherDummyData";
import DeviceLayoutDryerDummyData from "../../../dummy/DeviceLayoutDryerDummyData";
import Translate from "../../../common/translate/Translate";
import EditLayerTable from "../../../common/components/table/EditLayerTable";
import DeviceHoverCard from "../components/DeviceHoverCard";
import { Theme } from "../../../common/Theme";

const mockData = DeviceLayoutDummyData;

const mockEntranceLayout = {
    column: 1,
    row: 1,
    type: "t",
};

const mockWasherDevices = DeviceLayoutWasherDummyData;

const mockDryerDevices = DeviceLayoutDryerDummyData;

const MenuContainer = styled.div`
    position: relative;
    display: flex;
    align-items: flex-start;
`;

function DeviceImageCard({ device, selectedDevice, setSelectedDevice }) {
    const [openedTooltip, setOpenedTooltip] = useState(undefined);
    const menuRef = useRef(null);

    return (
        <MenuContainer
            ref={menuRef}
            onMouseEnter={() => setOpenedTooltip(true)}
            onMouseLeave={() => setOpenedTooltip(undefined)}
        >
            <SizedBox
                height={"auto"}
                width={"100%"}
                padding={selectedDevice?.id === device.id ? "9px" : "10px"}
                onClick={() => setSelectedDevice(device)}
                border={selectedDevice?.id === device.id ? `1px solid ${Theme.color.indigo500}` : "none"}
            >
                <CustomImage imageName={`image_${device.type}`} width={"29px"} height={"36px"} />
                <SizedBox height={"6px"} />
                <C3Text textAlign={"center"}>{device.name}</C3Text>
            </SizedBox>
            {openedTooltip && <DeviceHoverCard device={device} openedLeftSide={false} top={"50%"} />}
        </MenuContainer>
    );
}

function DeviceLayoutEditModal({ isOpen, onClose }) {
    const [selectedWidth, setSelectedWidth] = useState(8);
    const [selectedHeight, setSelectedHeight] = useState(4);
    const [selectedType, setSelectedType] = useState("washer");
    const [washerDevices, setWasherDevices] = useState(mockWasherDevices);
    const [dryerDevices, setDryerDevices] = useState(mockDryerDevices);
    const [modalHeight, setModalHeight] = useState();
    const [selectedDevice, setSelectedDevice] = useState(undefined);

    useEffect(() => {
        if (selectedHeight === 4) setModalHeight("680.5px");
        if (selectedHeight === 5) setModalHeight("792.5px");
        if (selectedHeight === 6) setModalHeight("904.5px");
        if (selectedHeight === 7) setModalHeight("1016.5px");
        if (selectedHeight === 8) setModalHeight("1100px");
    }, [selectedHeight, modalHeight]);

    if (!isOpen) {
        return null;
    }

    return ReactDOM.createPortal(
        <ModalOverlay onClick={onClose}>
            <Row>
                <ModalContainer onClick={(e) => e.stopPropagation()} width={"380px"} height={modalHeight}>
                    <Row width={"100%"} padding={"21px 27px 21px 27px"} justifyContent={"space-between"}>
                        <CustomText fontSize={"18px"} fontWeight={"700"}>
                            Setting
                        </CustomText>
                    </Row>
                    <Divider />
                    <ModalContent padding={"0"}>
                        <Padding padding={"11px 20px"}>
                            <TitleAndInput
                                title={"Width"}
                                type={"select"}
                                inputValue={selectedWidth}
                                setInputValue={setSelectedWidth}
                                dropdownValues={[
                                    { label: "8", value: 8 },
                                    { label: "9", value: 9 },
                                    { label: "10", value: 10 },
                                    { label: "11", value: 11 },
                                    { label: "12", value: 12 },
                                ]}
                            />
                            <Divider thickness={"0"} marginTop={"10px"} />
                            <TitleAndInput
                                title={"Height"}
                                type={"select"}
                                inputValue={selectedHeight}
                                setInputValue={setSelectedHeight}
                                dropdownValues={[
                                    { label: "4", value: 4 },
                                    { label: "5", value: 5 },
                                    { label: "6", value: 6 },
                                    { label: "7", value: 7 },
                                    { label: "8", value: 8 },
                                ]}
                            />
                        </Padding>

                        <Divider />
                        <Padding padding={"11px 20px"}>
                            <Row justifyContent={"space-between"} width={"100%"}>
                                <TitleAndInputGrid>
                                    <Row alignItem={"center"}>
                                        <C3Text>Entrance</C3Text>
                                    </Row>
                                    <SecondaryButton text={"Entrance Setting"} icon={"entrance"} width={"140px"} />
                                </TitleAndInputGrid>
                            </Row>
                        </Padding>
                        <Divider />
                        <Padding padding={"14px 20px"}>
                            <Row justifyContent={"space-between"} width={"100%"}>
                                <CustomSegmentedControl
                                    values={[
                                        { label: Translate("common.washer"), value: "washer" },
                                        { label: Translate("common.dryer"), value: "dryer" },
                                    ]}
                                    currentValue={selectedType}
                                    setValue={setSelectedType}
                                />
                                <Row>
                                    <C4Text>00</C4Text>
                                    <C4Text fontColor={Theme.color.gray500}>/06</C4Text>
                                </Row>
                            </Row>
                            <SizedBox height={"20px"} />
                            <SingleScrollView
                                $gridTemplateColumns={"repeat(auto-fill, 80px)"}
                                $gap={4}
                                $overflowX={"visible"}
                            >
                                {selectedType === "washer"
                                    ? washerDevices.map((device, index) => (
                                          <DeviceImageCard
                                              key={index}
                                              device={device}
                                              selectedDevice={selectedDevice}
                                              setSelectedDevice={setSelectedDevice}
                                          />
                                      ))
                                    : dryerDevices.map((device, index) => (
                                          <DeviceImageCard
                                              key={index}
                                              device={device}
                                              selectedDevice={selectedDevice}
                                              setSelectedDevice={setSelectedDevice}
                                          />
                                      ))}
                            </SingleScrollView>
                        </Padding>
                    </ModalContent>
                </ModalContainer>
                <SizedBox width={"20px"} />
                <ModalContainer onClick={(e) => e.stopPropagation()} width={selectedWidth <= 10 ? "952px" : "1200px"}>
                    <Row width={"100%"} padding={"21px 27px 21px 27px"} justifyContent={"space-between"}>
                        <CustomText fontSize={"18px"} fontWeight={"700"}>
                            Edit Layout
                        </CustomText>
                        <CustomIcon iconName={"close"} onClick={onClose} size={"24px"} cursor={"pointer"} />
                    </Row>
                    <Divider />
                    <ModalContent padding={"20px 20px"}>
                        <Row width={"100%"} justifyContent={"space-between"}>
                            <SecondaryButton text={"Remove All Devices"} icon={"arrow_rotate_left"} />
                            <C4Text fontWeight={"400"}>Washer(0 Left)/Dryer(0 Left)</C4Text>
                        </Row>
                        <SizedBox height={"20px"} />
                        <EditLayerTable
                            column={selectedWidth}
                            row={selectedHeight}
                            data={mockData}
                            entranceLayout={mockEntranceLayout}
                            cellWidth={100}
                            cellHeight={112}
                        />
                        <SizedBox height={"20px"} />
                        <Row justifyContent={"space-between"}>
                            <SecondaryButton text={"Close"} />
                            <PrimaryButton text={"Save"} />
                        </Row>
                    </ModalContent>
                </ModalContainer>
            </Row>
        </ModalOverlay>,
        document.getElementById("modal-root")
    );
}

export default DeviceLayoutEditModal;
